const PARTNERS = [
  {
    name: 'Wirex',
    role: 'Strategic card and account rail',
    logo: 'https://static.wixstatic.com/media/f627bc_a76833f464ff4134b15ce229026771b8~mv2.png/v1/fill/w_182,h_40,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Wirex_logo_white.png',
    logoClass: 'h-[34px] w-[150px]',
  },
  {
    name: 'Circle',
    role: 'Stablecoin infrastructure',
    logo: '/partners/circle-logo-white.png',
    logoClass: 'h-[42px] w-[168px]',
  },
  {
    name: 'Privy',
    role: 'Wallet onboarding and embedded wallet infrastructure',
    logo: '/partners/privy-brandmark-white.png',
    logoClass: 'h-[44px] w-[168px]',
  },
  {
    name: 'Arc',
    role: 'Ecosystem and distribution partner',
    logo: '/partners/arc-logo-white.svg',
    logoClass: 'h-[46px] w-[130px]',
  },
  {
    name: 'xMoney',
    role: 'Payments and ecosystem distribution',
    logo: 'https://cdn.prod.website-files.com/67e28295730835faa3d902aa/67e299ca49b4aba8f5de89d5_X%20Money.svg',
    invert: true,
    logoClass: 'h-[34px] w-[150px]',
  },
];

export default function StrategicPartners() {
  return (
    <div className="pulsar-surface-dark rounded-card text-white p-7">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
        <div>
          <p className="caption text-ice-300">Strategic partner stack</p>
          <h3 className="h3 mt-2">Built with close strategic partners.</h3>
        </div>
        <p className="label text-carbon-300 max-w-md">
          Pulsar combines card rails, stablecoin infrastructure, embedded wallets, ecosystem
          distribution, and payment partners into one launch plan.
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mt-7" data-partners>
        {PARTNERS.map((partner) => (
          <div
            key={partner.name}
            data-partner-card={partner.name}
            className="flex min-h-44 flex-col rounded-box border border-white/10 bg-white/[0.04] p-5"
          >
            <div className="flex h-16 shrink-0 items-center justify-start" data-logo-slot>
              {partner.logo ? (
                <img
                  src={partner.logo}
                  alt={`${partner.name} logo`}
                  loading="lazy"
                  decoding="async"
                  className={`block max-w-full object-contain object-left ${partner.logoClass} ${partner.invert ? 'brightness-0 invert' : ''}`}
                />
              ) : (
                <span className="text-2xl font-semibold tracking-h2">{partner.textLogo}</span>
              )}
            </div>
            <p className="caption text-carbon-500 mt-5" data-partner-label>
              {partner.name}
            </p>
            <p className="label text-carbon-300 mt-2 leading-snug">{partner.role}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
